const images = [
  "https://images.unsplash.com/photo-1731740669522-dde964c973bd",
  "https://images.pexels.com/photos/4756887/pexels-photo-4756887.jpeg",
  "https://images.pexels.com/photos/29198168/pexels-photo-29198168.jpeg",
  "https://images.unsplash.com/photo-1759169955484-1cb6f123fc64",
];

export const Gallery = ({ t }) => {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative bg-zinc-950 py-24 md:py-32 border-t border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-14">
          <div className="lg:col-span-5">
            <span className="overline">{t.gallery.overline}</span>
            <h2 className="font-heading mt-5 text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tighter text-zinc-50">
              {t.gallery.title}
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="font-body text-zinc-400 text-base md:text-lg leading-relaxed">
              {t.gallery.subtitle}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 grid-rows-2 gap-2 md:gap-3 h-[480px] md:h-[640px]">
          <div className="row-span-2 col-span-2 md:col-span-2 overflow-hidden">
            <img
              src={images[0]}
              alt="Workshop bay"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
            />
          </div>
          <div className="overflow-hidden">
            <img
              src={images[1]}
              alt="Diagnosis equipment"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
            />
          </div>
          <div className="overflow-hidden">
            <img
              src={images[2]}
              alt="Mechanic working"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
            />
          </div>
          <div className="overflow-hidden col-span-2">
            <img
              src={images[3]}
              alt="Tools and equipment"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
